
import { Component, Prop, Vue } from "vue-property-decorator";
import ImageSponsorLicence from "@/modules/Compliance/Widgets/assets/images/sponsor_licence.png";
import { TCase_Create } from "@/models/cases";
import { SPONSOR_LICENCE_SERVICE } from "@/constants/services";
import { API_ROUTES } from "@/utils/API";
import { SMCases, SMUser } from "@/store";
import { API_TCompany } from "@/models/cases_expert_companies";

const EMPLOYER_CCA_REQUEST_ALIAS = "employer_cca";

const ICONS = {
  check: "checkmark-sharp",
  alert: "alert-circle",
};

const SERVICE = {
  id: 1,
  alias: EMPLOYER_CCA_REQUEST_ALIAS,
};

@Component
export default class WidgetGetSponsorLicenceDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: Number }) readonly serviceFromId?: number;

  service = SERVICE;

  icons = ICONS;

  imageSponsorLicence = ImageSponsorLicence;

  closePopup(bool: boolean): void {
    if (bool) return;

    this.$emit("input", false);
  }

  getServiceAlias() {
    const item = this.service;

    if (!item) return null;

    return item.alias;
  }

  loading = false;

  async submitRequest() {
    const alias = this.getServiceAlias();

    if (!alias) return;

    try {
      this.loading = true;

      const params = {
        company_id: ((SMCases.case as unknown) as API_TCompany).company_id ?? 0,
      };

      const { data } = await this.axios.get<number | TCase_Create>(
        API_ROUTES.CASE_CREATE(SPONSOR_LICENCE_SERVICE, params)
      );

      if (!data) return;

      let caseId = 0;

      if (typeof data === "number") caseId = data;

      if (typeof data === "object") caseId = data?.case_id ?? 0;

      if (!caseId) return;

      await this.$router.push(`/cases/${caseId}/dashboard/${SMCases.tabId}`);

      this.$emit("update-report");

      await SMUser.updateCurrentUser();
    } finally {
      this.closePopup(false);

      this.loading = false;
    }
  }
}
